import {
  diagram as originalDiagram,
  related,
  sourceIds,
} from './puzzles__pulse-fitness.mdx';

export { sourceIds, related };

export const diagram = {
  ...originalDiagram,
  src: '/diagrams/zh/pulse-fitness-sequence.svg',
  sourceId: 'pulse-fitness-sequence',
  caption:
    '原创示意图：跑步机 0.5 → 健身车 15 → 自动售货机 → 跑步机 15 → 健身车 0.5。',
  alt: '跑步机 0.5 → 健身车 15 → 自动售货机 → 跑步机 15 → 健身车 0.5。',
};
export const quickAnswer =
  '跑步机 0.5 → 健身车 15 → 自动售货机 → 跑步机 15 → 健身车 0.5。';

## Pulse Fitness 在哪里？

Pulse Fitness 位于 The Unknown，留意紫色招牌。如果同一位置看起来是美术馆，切换重力方向，前往健身房所在的街面。

## 正确操作顺序

1. 操作标为 0.5 MPH 的跑步机。
2. 操作标为 15 MPH 的自行车。
3. 操作自动售货机。
4. 操作标为 15 MPH 的跑步机。
5. 最后操作标为 0.5 MPH 的自行车。

## 为什么我看到的是画廊？

同一区域存在相反的重力方向。切换方向，找到紫色 Pulse Fitness 招牌所在的街面，不要在画廊套用健身房的操作顺序。

## 完成后会发生什么？

隐藏房间会打开，进入后收集生命升级物品。

## 机器用了但没开门

同时核对机器类型和速度标签。第一次健身车和第二次跑步机都是 15，最后健身车为 0.5。门打开后进入房间，拿取生命升级物品。
